import clsx from 'clsx';

import logoLargeActionSrc from '~/src/assets/logo/large-action.png';
import logoLargeNeutralSrc from '~/src/assets/logo/large-neutral.png';
import logoLargeWhiteSrc from '~/src/assets/logo/large-white.png';
import constants from '~/src/constants';

import styles from './Logo.module.scss';

const Variants = {
  neutral: logoLargeNeutralSrc,
  action: logoLargeActionSrc,
  white: logoLargeWhiteSrc,
};

interface Props {
  variant?: keyof typeof Variants;
  className?: string;
}

export const Logo = ({ variant = 'white', className }: Props) => {
  return (
    <img
      src={Variants[variant]}
      alt={constants.BRAND_NAME}
      className={clsx(styles.logo, className)}
    />
  );
};
